import store from '../store/store';
import { getStudy } from './elementsUtils';
import { selectSeries } from '../components/App/Viewer/Layout/LayoutUtils';

export const drop = (e, key) => {
  e.preventDefault();

  const viewObj = e.dataTransfer.getData('viewObj');

  if (viewObj) {
    const droppedView = JSON.parse(viewObj);
    const { StudyInstanceUID, SeriesInstanceUID } = droppedView;
    const { patient } = store.getState();
    const study = getStudy(patient, StudyInstanceUID);
    const series = typeof study.seriesMap.get === 'function'
      ? study.seriesMap.get(SeriesInstanceUID)
      : study.seriesMap[SeriesInstanceUID];

    selectSeries(study, series, key); // change this function name
  }
};

export const allowDrop = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
};

export const onDragHandler = (e, idx, study, series) => {
  const viewObj = {
    StudyInstanceUID: study.StudyInstanceUID,
    SeriesInstanceUID: series.SeriesInstanceUID,
  };
  e.dataTransfer.setData('viewObj', JSON.stringify(viewObj));
  e.dataTransfer.dropEffect = 'move';
};
